export default __webpack_public_path__ + "static/05-budgeting-2ec68042cbba993a1875a5bd602be2b5.png";